import useMonolithApiQuery from '@/hooks/api/useMonolithApiQuery';
import { LicensePool } from './LicensePoolsSettings.types';

const useLicensePools = (slug: string, isEnabled: boolean) => {
  const { data, isLoading, refetch } = useMonolithApiQuery<LicensePool[], null>(
    ['licensePools', slug],
    `/organizations/${slug}/license_pools`,
    {
      enabled: isEnabled,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  );
  return { data, isLoading, refetch };
};

export default useLicensePools;
